<template>
  <router-view />
</template>

<script setup>
// Empty on purpose — all layout handled in BaseLayout
</script>
